// @flow

import axios from 'axios';
import { getBaseUrl } from '../../config/config';

export default function getDurationProfile(projectId: string): Promise<Object> {
  return axios.get(`${getBaseUrl()}projects/${projectId}/insights/weekly/duration_profile`);
}
